import { FC } from 'react';

export const Page404: FC = () => {
  return <p>404ページ</p>;
};
